import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "unsupported-page" }
const _hoisted_2 = { class: "unsupported-page__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "unsupported-page__divider" }, null, -1)
const _hoisted_4 = { class: "unsupported-page__title" }
const _hoisted_5 = { class: "unsupported-page__body" }

import VisualiserLogo from '@/assets/VisualiserLogo.svg'
import Badge from '@/components/nav/Badge.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'UnsupportedPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(VisualiserLogo), { class: "unsupported-page__header-logo" }),
      _createVNode(Badge, {
        class: "unsupported-page__header-badge",
        text: "BETA"
      })
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "title")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "body")
    ])
  ]))
}
}

})